import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreKey } from '@/configs/storeKeys';

export interface AppState {
	loading: boolean;
	errorCode: string;
}

const initialState: AppState = {
	loading: false,
	errorCode: '',
};

export const appSlice = createSlice({
	name: StoreKey.APP,
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setErrorCode: (state, action: PayloadAction<string>) => {
			state.errorCode = action.payload;
		},
	},
});

export const { setLoading, setErrorCode } = appSlice.actions;

export const selectAppState = <State extends { app: AppState }>(state: State) => state.app;
export default appSlice.reducer;
